// @flow

import { gql } from "@apollo/client";
import { graphql } from '@apollo/client/react/hoc';
import { fragments as screenPrintingOrderStatusFragments } from "../../application/apps/ScreenPrintingApp/components/ScreenPrintingOrderStatus/graph";

const markOrderAsScreenPrintingCompleted: any = graphql(
  gql`
    mutation($orderId: ID!) {
      markOrderAsScreenPrintingCompleted(orderId: $orderId) {
        errors {
          orderId
        }
        order {
          ...ScreenPrintingOrderStatus_order
        }
        succeeded
      }
    }
    ${screenPrintingOrderStatusFragments.order}
  `,
  {
    name: "markOrderAsScreenPrintingCompleted"
  }
);

export default markOrderAsScreenPrintingCompleted;
